import React from 'react'

const SliderRight = () => (
  <svg viewBox="0 0 65 65">
    <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
      <path d="M33 53.047c2.906 0 5.633-.555 8.18-1.664 2.547-1.11 4.765-2.617 6.656-4.524 1.89-1.906 3.39-4.132 4.5-6.68C53.446 37.634 54 34.907 54 32c0-2.906-.555-5.633-1.664-8.18-1.11-2.547-2.61-4.765-4.5-6.656-1.89-1.89-4.11-3.39-6.656-4.5C38.633 11.554 35.906 11 33 11c-2.906 0-5.633.555-8.18 1.664-2.547 1.11-4.765 2.61-6.656 4.5-1.89 1.89-3.39 4.11-4.5 6.656C12.554 26.367 12 29.094 12 32c0 2.906.555 5.633 1.664 8.18 1.11 2.547 2.61 4.773 4.5 6.68 1.89 1.906 4.11 3.413 6.656 4.523 2.547 1.11 5.274 1.664 8.18 1.664z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M24 32h18m-6.207-6L42 32l-6.207 6" />
    </g>
  </svg>
);

export default SliderRight
